module.exports = __webpack_public_path__ + "static/media/server_maintenance.ee8ef50c.png";